import * as React from "react";
import { observable, computed, action } from "mobx";
import { observer, inject } from "mobx-react";
import { NotificationStore } from "../Stores/NotificationStore";
import { DocumentPrivilegeInfoEdit } from "./DocumentPrivilegesEdit.Info";
import * as DocumentManagement from "../DocumentManagement";
import { getDocumentPrivilegeNamesAsync } from "../Strings";
import { InputBoolean, PrivilegeMembership } from "../Shared";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import { Strings } from "../Stores/StringsStore";
import * as Utilities from "../Utilities";
import { DialogStore, DialogResult } from "../Stores/DialogStore";


interface IDocumentPrivilegesEditProps {
	document: DocumentManagement.DocumentDetails;
	collectionId: string;
	documentStore?: DocumentStoreImpl;
}

@inject('documentStore')
@observer
export class DocumentPrivilegesEdit extends React.Component<IDocumentPrivilegesEditProps, {}> {

	@observable searchTerm: string = "";
	@observable isForCurrentDocumentOnly: InputBoolean;
	@observable privilegesNames: string[] = [];
	searchTimeoutHandle: number;

	componentWillMount() {
		this.isForCurrentDocumentOnly = new InputBoolean();
		this.isForCurrentDocumentOnly.label = "For current Document";
		this.isForCurrentDocumentOnly.value = false;
		this.props.documentStore.handlePrivilegesDelete = this.handlePrivilegesDelete;
		let uiLang = Utilities.getUiLanguage();
		if (!uiLang) {
			uiLang = "en-US";
		}
		getDocumentPrivilegeNamesAsync(uiLang).then(names => this.privilegesNames = names);
	}


	getGroupPrivileges() {
		DocumentManagement.queryDocumentPrivilegeInfosAsync({ collectionId: this.props.collectionId, documentId: this.props.document.guid, searchTerm: this.searchTerm }).then(result => {
			this.props.document.privileges = result;
		}).catch(error => {
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}

	handleSearchTermChange = (event: React.FormEvent<any>) => {
		this.searchTerm = (event.target as any).value as string;
		clearTimeout(this.searchTimeoutHandle);
		this.searchTimeoutHandle = setTimeout(() => this.getGroupPrivileges(), 300);
	}

	handleNoPrivilegeSpanClick = () => {
		this.props.documentStore.privilegesWizardStore.open();
	}

	@action handlePrivilegesDelete = () => {
		DialogStore.show(Strings.documentManagement.collectionEdit.deletePrivilegesDialogTitle, Strings.documentManagement.collectionEdit.deletePrivilegesDialogText).then(result => {
			if (result == DialogResult.Yes) {
				this.props.documentStore.addedPrivileges = this.props.documentStore.addedPrivileges.filter(p => this.props.documentStore.selectedPrivileges.indexOf(p) < 0);
				this.props.documentStore.selectedPrivileges.forEach(p => {
					if (this.props.document.privileges.privilegesForGroups.remove(p)) {
						this.props.documentStore.removedDocumentPrivileges.push(p);
					}
					p.privilegeMemberships.forEach(m => m.isExplicitMemberOf = false);
				});
				this.props.documentStore.selectedPrivileges.clear();
				this.props.documentStore.updateImplicitPrivileges(this.props.document, this.props.collectionId);
			}
		});
	}

	@computed get privilegeListClass(): string {
		return this.props.documentStore.privilegeSelectionMode ? "list-advanced privilegeEdit is--selection" : "list-advanced privilegeEdit";
	}

	render() {
		/*
		  List the existing privileges and selected privileges
		*/
		return this.privilegesNames.length != 0 && (this.props.document.privileges.privilegesForGroups.length > 0 || this.props.documentStore.addedPrivileges.length > 0) ? <div className={this.privilegeListClass}>

			<table className="is--type-mobile is--rotate-headers" data-test-id="privileges">
				<thead>
					<tr>
						<th key="groupName"></th>
						{this.props.documentStore.privilegeSelectionMode ? <th></th> : null}
						{this.privilegesNames.map(name => {
							return <th className="short-header" key={name} title={name}>
								<div>
									<span>{name}</span>
								</div>
							</th>
						})}
					</tr>
				</thead>
				<tbody>
					{this.props.document.privileges.privilegesForGroups.map(item => {
						return <DocumentPrivilegeInfoEdit collectionId={this.props.collectionId} key={item.groupId} groupId={item.groupId} document={this.props.document} item={item} />
					})}

					{this.props.documentStore.addedPrivileges.map(item => {
						return <DocumentPrivilegeInfoEdit collectionId={this.props.collectionId} key={item.groupId} groupId={item.groupId} document={this.props.document} item={item} />
					})}
				</tbody>
			</table>
		</div> :
			<div className="inside__note is--clickable-note" onClick={this.handleNoPrivilegeSpanClick}>
				<span>
					{Strings.documentManagement.documentEdit.documentEmptyPrivilegeResultText}
				</span>
			</div>;
	}
}


